import { render } from "./SkillsUser.vue?vue&type=template&id=42721ed7&scoped=true"
import script from "./SkillsUser.vue?vue&type=script&lang=js"
export * from "./SkillsUser.vue?vue&type=script&lang=js"

import "./SkillsUser.vue?vue&type=style&index=0&id=42721ed7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42721ed7"]])

export default __exports__